import { AccountCircle } from "@mui/icons-material";
import { Button, Grid, Typography } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Panel } from "@poseidon/ui/components/Panel";
import { useNavigate } from "react-router-dom";
import NestedField from "./NestedField";
import EditApplicationFormWrapper from "./EditApplicationFormWrapper";
import { getUserLabel } from "../../../Users/util";

export function ApplicationApplicantsPanel({ application }) {
  const navigate = useNavigate();
  const renderPreview = (field) => (
    <List
      disablePadding
      sx={{ border: 1, borderStyle: "dashed", borderColor: "neutral.300" }}
    >
      <ListItem disablePadding>
        <ListItemButton
          onClick={() =>
            navigate(
              `/applications/${application.id}/sailors/${field.sailor?.id}`
            )
          }
        >
          <ListItemText
            primary={getUserLabel(field.sailor)}
            secondary={
              <Typography variant="subtitle" color="textSecondary">
                View Sailor
              </Typography>
            }
          />
          <ListItemIcon>
            <AccountCircle />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
    </List>
  );
  const renderJointPreview = (field) => (
    <List>
      <ListItem disablePadding>
        <ListItemButton
          onClick={() =>
            navigate(
              `/applications/${application.id}/sailors/${field.sailor?.id}`
            )
          }
        >
          <ListItemText
            primary={`${field.sailor?.firstName} ${field.sailor?.lastName}`}
            secondary={
              <Typography variant="subtitle" color="textSecondary">
                View Joint Sailor
              </Typography>
            }
          />
          <ListItemIcon>
            <AccountCircle />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
    </List>
  );
  return (
    <EditApplicationFormWrapper initialValues={application}>
      {({ isSubmitting, dirty, values }) => (
        <Panel
          expandable
          title="Applicants"
          actions={
            <Button
              size="small"
              type="submit"
              disabled={!dirty || isSubmitting}
            >
              Save
            </Button>
          }
        >
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12} sm={6}>
              {values.applicant && (
                <>
                  <NestedField
                    field={values.applicant}
                    renderPreview={renderPreview}
                  />
                  {/*<br />*/}
                  {/*<FormControlLabel*/}
                  {/*  control={*/}
                  {/*    <Field*/}
                  {/*      component={Checkbox}*/}
                  {/*      type="checkbox"*/}
                  {/*      name="isJoint"*/}
                  {/*    />*/}
                  {/*  }*/}
                  {/*  label="Is Joint Application"*/}
                  {/*/>*/}
                </>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              {values.joint && values.jointApplicant?.sailor && (
                <NestedField
                  field={values.jointApplicant}
                  renderPreview={renderJointPreview}
                />
              )}
            </Grid>
          </Grid>
        </Panel>
      )}
    </EditApplicationFormWrapper>
  );
}
